module.exports = __webpack_public_path__ + "assets/img/1.1956bd87.png";